@if (model$ | async) {
    <div class="card">
        <h5 class="card-header">Inventory Count Status | Weekly</h5>
        <div class="filter-block">
            <pcg-date-range [(dateRange)]="filters.dateRange" [maxDate]="null" (dateRangeChange)="reloadTable()">
            </pcg-date-range>
        </div>
        <table class="table">
            <tbody>
                <tr>
                    <td>Scheduled</td>
                    <td>
                        <a class="detail" (click)="linkClick(0)">{{ model.scheduled }}</a>
                    </td>
                    <td>--</td>
                </tr>
                @if (model.pending > 0) {
                    <tr>
                        <td>Pending</td>
                        <td>
                            <a class="detail" (click)="linkClick(1)">{{ model.pending }}</a>
                        </td>
                        <td>{{ model.percentPending }}%</td>
                    </tr>
                }
                <tr>
                    <td>Missed</td>
                    <td>
                        <a class="detail" (click)="linkClick(3)">{{ model.missed }}</a>
                    </td>
                    <td>{{ model.percentMissed }}%</td>
                </tr>
                <tr>
                    <td>Completed</td>
                    <td>
                        <a class="detail" (click)="linkClick(2)">{{ model.completed }}</a>
                    </td>
                    <td>{{ model.percentComplete }}%</td>
                </tr>
            </tbody>
        </table>
    </div>
}
